import React, { ReactNode } from "react";
import { useLanguage } from "../../i18n/LanguageContext";
import { SanityGenericDownload } from "../../model/common";
import { internalLinkUrl, URLParts } from "../../urls";
import Link from "../Link/Link";

export interface InternalLinkProps {
  children: ReactNode;
  className?: string;
  style?: React.CSSProperties;
  reference?: URLParts | SanityGenericDownload;
  fragment?: string;
  query?: string;
}

const InternalLink = ({
  children,
  className,
  style,
  reference,
  query,
  fragment
}: InternalLinkProps) => {
  const language = useLanguage();
  const to = internalLinkUrl(reference, query, fragment, language);
  if (!to) {
    return <>{children}</>;
  }
  return (
    <Link style={style} className={className} to={to}>
      {children}
    </Link>
  );
};

export { internalLinkUrl };

export default InternalLink;
